import script from "./LoginDialogue.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginDialogue.vue?vue&type=script&setup=true&lang=ts"

import "./LoginDialogue.vue?vue&type=style&index=0&id=9fb5c264&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fb5c264"]])

export default __exports__